const ZOOM_PRECISION_MAP = {
    1: 1,
    2: 2,
    3: 3,
    4: 3,
    5: 4,
    6: 4,
    7: 4,
    8: 5,
    9: 7,
    10: 8,
    11: 9,
    12: 9,
    13: 9,
    14: 10,
    15: 11,
    16: 11,
    17: 12,
    18: 12,
    19: 12
}



const EMIT_SEARCH = (value, query, _) => {

    if (value.length === 0) {
        return
    }

    query.query.bool.must.push({
        bool: {
            should: [
                { match: { 'company.name': { query: value, boost: 5 } } },
                { match: { title: { query: value, boost: 5 } } },
                { match: { description: { query: value, boost: 5 } } }
            ],
            minimum_should_match: 1
        }
    });

    query["highlight"] = {
        pre_tags: ["<cite>"],
        post_tags: ["</cite>"],
        fields: {
            _all: {},
            title: { number_of_fragments: 0, force_source: true },
            description: { number_of_fragments: 0, force_source: true },
            "company.name": { number_of_fragments: 0, force_source: true }
        }
    }

}

const EMIT_BOUNDS = (value, query, params) => {

    let filter = {};

    if (value.bottom_left[1] < -180 || value.top_right[1] > 180) {

        filter['bool'] = {
            should: [
                { geo_bounding_box: { ["locations.location"]: value } }
            ]
        }

        if (value.bottom_left[1] < -180) {

            let extra_bounds = {
                bottom_left: [
                    value.bottom_left[1] + 180 * 2,
                    value.bottom_left[2]
                ],
                top_right: [
                    180,
                    value.top_right[2]
                ]
            }

            value.bottom_left[1] = -180

            filter['bool']['should'].push({
                geo_bounding_box: { ["locations.location"]: extra_bounds }
            })
        }

        if (value.top_right[1] > 180) {

            let extra_bounds = {
                bottom_left: [
                    -180,
                    value.bottom_left[2]
                ],
                top_right: [
                    -180 * 2 + value.top_right[1],
                    value.top_right[2]
                ]
            }

            value.top_right[1] = 180

            filter['bool']['should'].push({
                geo_bounding_box: { ["locations.location"]: extra_bounds }
            })
        }

    } else {
        filter['geo_bounding_box'] = { ["locations.location"]: value }
    }

    let nested = {
        inner_hits: {
            size: 3,
        },
        path: "locations",
        query: {
            bool: {
                filter: filter
            }
        }
    };

    if (params.center) {
        nested.inner_hits.sort = {
            _geo_distance: {
                ["locations.location"]: {
                    lat: params.center.lat,
                    lon: params.center.lng
                },
                order: "asc",
                unit: "km",
                distance_type: "plane"
            }
        }
    }

    query.query.bool.filter.bool.must.push({
        nested: nested
    })

}

const EMIT_REMOTE = (value, query, params) => {
    query.query.bool.filter.bool.must.push({
        term: { remote: true }
    });
}

const EMIT_VISA = (value, query, params) => {
    query.query.bool.filter.bool.must.push({
        term: { visa: true }
    });
}

const EMIT_TIME = (value, query, params) => {
    query.query.bool.filter.bool.must.push({
        range: {time: {gt: value}}
    });
}

const EMIT_DISTANCE = (value, query, params) => {
    
    query.query.bool.filter.bool.must.push({
        nested: {
            path: "locations",
            query: {
                bool: {
                    filter: {
                        geo_distance: {
                            distance: value,
                            ["locations.location"]: {
                                lat: params.center.lat,
                                lon: params.center.lng
                            }
                        }
                    }
                }
            }
        }
    })
}

const EMIT_NOOP = (..._) => null;

const FIELD_MAP = {

    location:   EMIT_NOOP,
    distance:   EMIT_DISTANCE,
    bounds:     EMIT_BOUNDS,
    search:     EMIT_SEARCH,
    remote:     EMIT_REMOTE,
    visa:       EMIT_VISA,
    time:       EMIT_TIME,
    // type:        missing,
    // category:    missing,
}


const emit = (params) => {

    let query = {
        query: {
            bool: {
                must: [],
                should: [],
                must_not: [],
                filter: {
                    bool: {
                        must: [],
                        should: [],
                        must_not: []
                    }
                }
            }
        }
    }

    for (const paramName in params) {
        const paramValue = params[paramName];

        if (paramValue) {
            if (paramName in FIELD_MAP) {
                FIELD_MAP[paramName](paramValue, query, params)
            } else {
                // console.error(`Missing definition for "${paramName}" with value ${JSON.stringify(paramValue)}`);
            }
        }
    }

    return query;
}

export const clusterQuery = (params) => {

    let zoom;

    if (params.zoom) {
        zoom = params.zoom;
    } else {
        zoom = 2;
    }

    let ret = emit(params);

    ret.aggs = {
        location: {
            nested: {
                path: "locations"
            },
            aggs: {
                polygons: {
                    filter: { match_all: {} },
                    aggs: {
                        clusters: {
                            geohash_grid: {
                                field: "locations.location",
                                precision: ZOOM_PRECISION_MAP[zoom]
                            },
                            aggs: {
                                centroid: {
                                    geo_centroid: {
                                        field: "locations.location"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    ret.size = 0;

    return ret;
};


export const countQuery = (params) => {
    return emit(params)
}

export const listQuery = (params) => {

    const sort_by_time = { time: { order: "desc", mode: "min" } };

    let ret = emit(params);

    ret.sort = [];

    if (params.order == "distance") {

        let sort_by_distance = {
            _geo_distance: {
                ['locations.location']: {lat: params.center.lat, lon: params.center.lng},
                nested_path: "locations",
                order: "asc",
                unit: "km",
                distance_type: "plane"
            }
        }

        ret.sort = [sort_by_distance, '_score', sort_by_time];

    } else if (params.order == "time") {
        ret.sort = [sort_by_time, '_score'];
    } else {
        ret.sort = ['_score', sort_by_time];
    }

    ret.sort.push({ id: { order: "asc" } });

    if (params.size) {
        ret['size'] = params.size;
    } else {
        ret['size'] = 15;
    }

    return ret

}
